@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.loadMore {
  display: flex;
  align-items: center;
  justify-content: left;
  margin-left: 22px;
  height: 40px;

  div:after {
    background: var(--default-bg);
  }
}

.loading {
  margin-left: 8px;
}

@include for-phone-only {
  .topContainer {
    li {
      display: flex;
      align-items: center;
      justify-content: stretch;

      a {
        flex: 1;
      }

      height: 40px;
    }
  }
}

.newProjectButton {
  [data-autopilot-system-redesign='on'] & {
    opacity: 0;
    pointer-events: none;

    &.isSidebarHovered {
      opacity: 1;
      pointer-events: all;
    }
  }
}
